
import {tabletPageModule} from "@/store/modules/tablet-page.module"
import { Vue, Options } from "vue-class-component";

@Options({
  beforeRouteEnter: async (to, from, next) => {
    await tabletPageModule.load(to.params.id as string)
    next()
  }
})
export default class TabletPageComponent extends Vue {

  get name() { return tabletPageModule.data.Name }

  onUnmounted() {
    tabletPageModule.reset()
  }

  onDeactivated() {
    tabletPageModule.reset()
  }
}
